/* ============================================================
   pm-search.js
   Interactive bits for the new /search page:
   - Reveal animation (IntersectionObserver)
   - Category tabs filter visible result sections by object_type
   - Clear button empties the input and submits to /search (= reset)
   ============================================================ */
(function(){
  var root = document.querySelector('.pm-search-root');
  if (!root) return;

  /* Reveal */
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if (e.isIntersecting) e.target.classList.add('in'); });
  }, { threshold: .12 });
  root.querySelectorAll('[data-reveal]').forEach(function(el){ io.observe(el); });

  /* Category tabs — toggle visible sections */
  var tabs = root.querySelectorAll('.cat-tab');
  var sections = root.querySelectorAll('.r-section');
  tabs.forEach(function(t){
    t.addEventListener('click', function(){
      tabs.forEach(function(x){ x.classList.remove('on'); });
      t.classList.add('on');
      var cat = t.getAttribute('data-cat');
      sections.forEach(function(sec){
        if (cat === 'all' || sec.getAttribute('data-section') === cat){
          sec.classList.remove('is-hidden');
        } else {
          sec.classList.add('is-hidden');
        }
      });
    });
  });

  /* Clear button — empty input + submit */
  root.querySelectorAll('[data-clear]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var form = btn.closest('form');
      if (!form) return;
      var input = form.querySelector('input[name="q"]');
      if (input) input.value = '';
      window.location.href = '/search';
    });
  });
})();
